@if (errors && errors.length > 0) {
  <div class="error-section d-flex align-items-start">
    @if (isOpen) {
      <div class="d-flex justify-content-center align-items-center">
        <div class="arrow bg-error pointer" (click)="toggleOpen()">
          <i class="pi pi-angle-right fw-bold"></i>
        </div>
        <div class="error-message">
          <div class="alert-message bg-error">Please fix the following errors to submit the application</div>
          <div class="panel-group m-0 p-0">
            <p-accordion [multiple]="true" [value]="[0]" class="no-border">
              @for (navSection of errors; track navSection) {
                <p-accordion-panel [value]="0" class="custom-toggle">
                  <p-accordion-header>
                    <span>{{ navSection.section }}</span>
                  </p-accordion-header>
                  <p-accordion-content>
                    <ul class="error-nav-list">
                      @for (error of navSection?.errors; track error) {
                        <li>
                          {{ error?.controlName }}:
                          @if (error?.controlId && !error?.errorLink) {
                            <a class="control-link" href="javascript:void(0)" (click)="goToControl(error?.controlId)">{{ error?.errorText }}</a>
                          }
                          @if (error?.errorLink) {
                            <a class="control-link" [href]="error?.errorLink">{{ error?.errorText }}</a>
                          }
                          @if (!error?.controlId && !error?.errorLink) {
                            <span>{{ error?.errorText }}</span>
                          }
                        </li>
                      }
                    </ul>
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        </div>
      </div>
    }
    <div class="error-icon bg-error" (click)="toggleOpen()"><i class="pi pi-exclamation-triangle"></i> Errors</div>
  </div>
}
